"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPagination = exports.StyledListItem = exports.StyledList = void 0;
exports.default = CustomList;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _List = _interopRequireDefault(require("@mui/material/List"));

var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Pagination = _interopRequireDefault(require("@mui/material/Pagination"));

var _Text = _interopRequireDefault(require("../Text"));

var _templateObject, _templateObject2, _templateObject3;

var StyledList = (0, _styledComponents.default)(_List.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    padding: 0px;\n  }\n"])));
exports.StyledList = StyledList;
var StyledListItem = (0, _styledComponents.default)(_ListItem.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n"])));
exports.StyledListItem = StyledListItem;
var StyledPagination = (0, _styledComponents.default)(_Pagination.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n"])));
exports.StyledPagination = StyledPagination;

function CustomList(_ref) {
  var data = _ref.data,
      renderListItem = _ref.renderListItem,
      itemPerPage = _ref.itemPerPage,
      defaultPage = _ref.defaultPage;

  // state variables
  var _useState = (0, _react.useState)(defaultPage),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = (0, _react.useState)(itemPerPage),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      currentItemPerPage = _useState4[0],
      setItemPerPage = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      pageCount = _useState6[0],
      setPageCount = _useState6[1]; // props change listeners and effects


  (0, _react.useEffect)(function () {
    if (typeof defaultPage === 'number' && defaultPage > 0 && page !== defaultPage) {
      // chack max page
      setPage(defaultPage);
    }
  }, [defaultPage]);
  (0, _react.useEffect)(function () {
    if (data.length > 0) {
      setPageCount(Math.ceil(data.length / currentItemPerPage));
    } else {
      setPageCount(0);
    }
  }, [data]);
  (0, _react.useEffect)(function () {
    if (typeof itemPerPage === 'number' && itemPerPage > 0 && currentItemPerPage !== itemPerPage) {
      setItemPerPage(itemPerPage);
    }
  }, [itemPerPage]); // page chane handler

  var handleChange = function handleChange(event, value) {
    setPage(value);
  }; // list item render


  var renderElement = function renderElement(element) {
    return /*#__PURE__*/_react.default.createElement(StyledListItem, {
      key: Math.random().toString(16)
    }, renderListItem(element));
  };

  var displayedData = data && data.length > 0 ? data.slice((page - 1) * currentItemPerPage, page * currentItemPerPage) : null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !displayedData && /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "span"
  }, "Pas de r\xE9sultat"), displayedData && /*#__PURE__*/_react.default.createElement(StyledList, null, displayedData.map(function (element) {
    return renderElement(element);
  })), pageCount > 0 && /*#__PURE__*/_react.default.createElement(StyledPagination, {
    count: pageCount,
    page: page,
    onChange: handleChange
  }));
}

CustomList.defaultProps = {
  itemPerPage: 10,
  defaultPage: 1
};